module.exports = __webpack_public_path__ + "img/default-user.29479ba0.png";